import { Injectable } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Injectable({
    providedIn: 'root',
})

export class CustomValidators {
    nameValidator(control: UntypedFormControl): { [key: string]: boolean } {
        const nameRegexp: RegExp = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
        if ((control.value && nameRegexp.test(control.value.charAt(0))) || (control.value && control.value.startsWith(' '))) {
            return { invalidName: true };
        }
    }
}


